import { createSelector } from 'reselect';
import { PRACTICE, QUESTIONS } from '../../constants/assessmentItemType';

export const getVocabFITBContent = (state, pageType, questionIndex = 0) => {
    let content;

    switch (pageType) {
    case PRACTICE:
        content = state.practice;
        break;
    case QUESTIONS:
        content = state.questions;
        break;
    default:
        content = [{}];
    }

    return content[questionIndex] || {};
};

export const getIsVocabFITBDataFetched = (state) => state.isDataFetched;

export const getVocabFITBStimulusInfo = createSelector(
    [getVocabFITBContent],
    (content) => content.stimulus || {},
);

export const getVocabFITBPossibleResponses = createSelector(
    [getVocabFITBContent],
    (content) => content.possibleResponses || [],
);

export const getMaxResponseLength = createSelector(
    [getVocabFITBContent],
    (content) => {
        if (content && content.possibleResponses) {
            return content.possibleResponses.reduce((maxLength, response) => (response.text.length > maxLength
                ? response.text.length
                : maxLength), 0);
        }

        return 0;
    },
);

export const getVocabFITBTotalQuestions = (state) => state.questions.length;

export const getVocabFITBFormId = (state) => state.formId;

export const getVocabFITBSelectedResponseId = (state, pageType, questionIndex, responseIdx) => {
    const possibleResponses = getVocabFITBPossibleResponses(state, pageType, questionIndex);

    if (possibleResponses && possibleResponses[responseIdx]) {
        return possibleResponses[responseIdx].id;
    }

    return undefined;
};
